<template>
  <article
    v-if="!childProduct && !shippingFeeProduct"
    :class="[
      'bag-item js-bag-item',
      isWishlist ? 'bag-item--wishlist' : '',
      isLoading ? 'is-loading' : '',
    ]"
    :id="`bagItem${variantId}-${id}`"
    :data-variant-id="variantId"
  >
  <CartItemDeliveryEstimate
    v-if="!isWishlist"
    :item="item"
    :isPhysical="isPhysical"
    :shippingMethodSelected="!!dropOffStoreProperty || !!shipToUsProperty"
    :dropOffStoreProperty="dropOffStoreProperty"
    :shipToUsProperty="shipToUsProperty"
    :estimatedDeliveryMetafield="item.metafield_estimated_delivery_date"
    :bundleDetails="bundleDetails"
    :allItems="allItems"
    :sharedZipcode="sharedZipcode"
    @zipcode-updated="onZipcodeUpdated"
  />
  <div class="bag-item__wrapper">
    <div class="bag-item__photo">
      <CartItemGallery
        :title="title"
        :image="image"
        :url="url"
        :frameSpec="frameSpec"
        :isLoading="isFrameSpecLoading"
        :line-item-id="item.id"
        :variantId="variantId"
        :productHandle="handle"
        :bundle-spec-number="bundleSpecNumber"
        :bundle-spec-token="bundleSpecAuthToken"
      />
      <span v-if="!isWishlist && !isGWP && allowSpecialInstructions" class="desktop-only">
        <CartItemInstructions
          :productId="id"
          :productProperties="itemProperties"
        />
      </span>
      </div>
    <header class="bag-item__header--mobile mobile-only">
      <h4 class="bag-item__title">
        <span
          v-if="item.properties?.['_is_gwp'] === 'true'"
          class="bag-item__title-text"
          v-html="title"
        ></span>
        <a
          v-else
          class="bag-item__title-link"
          :href="url"
          v-html="title"
        ></a>
      </h4>
      <p class="bag-item__price">
        <span class="bag-item__original-price">
          {{ itemProperties.customAmount ? `$${itemProperties.customAmount}` : moneyPrice}}
        </span>
        <PriceBreakdownTooltip
          v-if="frameSpec || bundlePricing"
          :frameSpec="frameSpec"
          :pricing="bundlePricing"
        />
      </p>
      <p class="bag-item__sku screenreader" alt-text="product sku">#{{ sku }}</p>
    </header>
    <div class="bag-item__info">
      <div class="bag-item__desc">
        <header class="bag-item__header desktop-only">
          <h4 class="bag-item__title">
            <span
              v-if="item.properties?.['_is_gwp'] === 'true'"
              class="bag-item__title-text"
              v-html="title"
            ></span>
            <a
              v-else
              class="bag-item__title-link"
              :href="url"
              v-html="title"
            ></a>
          </h4>
          <p class="bag-item__price">
            <span class="bag-item__original-price">
              {{ itemProperties.customAmount ? `$${itemProperties.customAmount}` : moneyPrice}}
            </span>
            <PriceBreakdownTooltip
              v-if="frameSpec || bundlePricing"
              :frameSpec="frameSpec"
              :pricing="bundlePricing"
            />
          </p>
          <p class="bag-item__sku screenreader" alt-text="product sku">#{{ sku }}</p>
        </header>
        <div v-if="!isGWP" class="bag-item__accordion">
          <div
            class="bag-item__accordion-wrapper"
            :class="(!mainDetails && !itemDetails ? 'bag-item__accordion-wrapper--no-details' : '')"
          >
            <ul
              v-if="mainDetails"
              class="bag-item__accordion-fields list-reset"
            >
              <li
                v-for="(detail) in Object.entries(mainDetails)"
                :key="detail[0]"
                class="bag-item__accordion-field"
              >
                <p
                  v-if="detail[0] && detail[1]"
                  class="bag-item__accordion-value bag-item__accordion-value--bold"
                >
                  {{ detail[0] }}:
                </p>
                <p
                  v-if="detail[0] && detail[1]"
                  class="bag-item__accordion-value"
                >
                  {{ detail[1] }}
                </p>
              </li>
              <li
                v-if="requiresShippingSurcharge"
                class="bag-item__accordion-field bag-item__surcharge-notice"
              >
                <p class="bag-item__accordion-value bag-item__accordion-value--with-icon">
                  Requires Large Shipping Fee
                  <div class="tooltip" :class="isShippingTooltipOpen ? 'tooltip--active' : ''">
                    <button
                      type="button"
                      class="bag__info-icon tooltip__button"
                      aria-label="Large shipping fee information"
                      @click="toggleShippingTooltip(true)"
                    >
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M8 7V11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                        <circle cx="8" cy="5" r="0.75" fill="currentColor"/>
                      </svg>
                    </button>
                    <div v-if="isShippingTooltipOpen" class="tooltip__modal tooltip__modal--text">
                      <p class="tooltip__text">
                        Our larger frames (sizes XL and G) require a Large Shipping Fee of $25 each. You can always pick up at a store for free.
                      </p>
                    </div>
                    <div
                      v-if="isShippingTooltipOpen"
                      class="tooltip-overlay"
                      @click="toggleShippingTooltip(false)"
                    />
                  </div>
                </p>
              </li>
            </ul>
            <VueAccordion
              v-if="itemDetails"
              :ariaTitle="variantTitle"
              :buttonPlacement="'bottom'"
              :buttonClass="'bag-item__accordion-button'"
            >
              <ul
                class="bag-item__accordion-fields list-reset"
              >
                <li
                  v-for="(subDetail) in Object.entries(itemDetails)"
                  :key="subDetail[0]"
                  class="bag-item__accordion-field"
                >
                  <p
                    v-if="subDetail[0]  && subDetail[1]"
                    class="bag-item__accordion-value bag-item__accordion-value--bold"
                  >
                    {{  subDetail[0] }}:
                  </p>
                  <p
                    v-if="subDetail[0]  && subDetail[1]"
                    class="bag-item__accordion-value"
                  >
                    {{  subDetail[1] }}
                  </p>
                </li>
              </ul>
              <template #opened-icon>
                <span class="bag-item__accordion-button--open">
                  Minimize Details
                </span>
              </template>

              <template #closed-icon>
                <span  class="bag-item__accordion-button--closed">
                  View All Details
                </span>
              </template>
            </VueAccordion>
          </div>
        </div>
      </div>

      <div
        v-if="!isGWP"
        class="bag-item__actions"
        :class="[
          isDigitalItem ? 'bag-item__actions--digital' : '',
          isPhysical && !isWishlist ? 'bag-item__actions--physical' : '',
        ]"
      >
        <div
          v-if="enableCartQuantity"
          class="bag-item__qty increment"
        >
          <input
            :value="itemQuantity"
            type="number"
            name="quantity"
            size="3"
            class="increment__input"
            tabindex="-1"
            aria-label="Item Quantity"
            readonly
          >
          <button
            type="button"
            class="increment__btn increment__add"
            data-action="add"
            :disabled="isLoading"
            @click.prevent="incrementQuantity"
          >
            <i class="increment__icon increment__icon--add bag-item__qty-icon icon icon--plus" />
            <span class="screenreader">Add</span>
          </button>
          <button
            type="button"
            class="increment__btn increment__subtr"
            data-action="remove"
            :disabled="isLoading || itemQuantity <= 1"
            @click.prevent="decrementQuantity"
          >
            <i class="increment__icon increment__icon--subtr bag-item__qty-icon icon icon--minus" />
            <span class="screenreader">Subtract</span>
          </button>
        </div>
        <div class="bag-item__actions-links">
          <div class="bag-item__actions-links__row">
            <a
              v-if="!isNonEditable"
              :href="frameEditParams"
              title="Edit item"
              class="bag-item__actions-btn-link"
              role="button"
            >
              <i class="icon icon--bag-edit"></i>
              <span>Edit</span>
              <span class="screenreader">Edit Item</span>
            </a>
            <button
              v-if="!isWishlist"
              title="Move to Wishlist"
              class="bag-item__actions-btn-link"
              @click.prevent="moveToWishlist"
            >
              <i class="icon icon--move-to-wishlist"></i>
              <span>Save For Later</span>
              <span class="bag-item__remove-label screenreader">Move to Wishlist</span>
            </button>
            <button
              title="Remove item"
              class="bag-item__actions-btn-link"
              role="button"
              @click.prevent="deleteModalOpen = true"
            >
              <i class="icon icon--bag-remove"></i>
              <span>Remove</span>
              <span class="bag-item__remove-label screenreader">Remove Item</span>
            </button>
            <button
              v-if="isWishlist"
              class="bag-item__actions-btn-link bag-item__actions-btn-link--bold"
              @click.prevent="moveToCart"
            >
              Move To Cart
            </button>
          </div>
          <div class="bag-item__actions-links__row">
            <span v-if="enableCartDuplication" class="bag-item__actions-links__caption">{{ duplicateCaptionText }}</span>
            <button
              v-if="enableCartDuplication"
              title="Duplicate item"
              class="bag-item__actions-btn-link"
              role="button"
              :disabled="isFrameSpecLoading"
              @click.prevent="duplicateModalOpen = true"
            >
              <i class="icon icon--bag-copy"></i>
              <span>Duplicate It</span>
              <span class="screenreader">Duplicate Item</span>
            </button>
          </div>
        </div>
      </div>

      <section v-if="!isWishlist && isPhysical" class="bag-item__options">
        <CartItemDeliveryMethod
          :variantId="variantId"
          :itemSelector="`bagItem${variantId}-${id}`"
          :isPhysical="isPhysical"
          :selectedDropOffStore="(currentlySelectedStore || {})"
          :parentProductId="id"
          :parentProductProperties="itemProperties"
          :dropOffStores="availableDropOffStores"
          :dropOffStoreProperty="dropOffStoreProperty"
          :handle="productHandle"
          :checkoutAvailable="checkoutAvailable"
          :hasPackageError="hasPackageError"
          :togglePackingError="togglePackingError"
          @set-ship-to-us="handleSetShipToUs"
        ></CartItemDeliveryMethod>
        <span class="mobile-only">
          <p
            v-if="hasPackageError"
            class="bag__content-error"
          >
            {{ cartCheckoutPackageError }}
          </p>
        </span>
      </section>
      <span v-if="!isWishlist && !isGWP && allowSpecialInstructions" class="mobile-only">
        <CartItemInstructions
          :productId="id"
          :productProperties="(itemProperties)"
          :isWishlist="isWishlist"
        />
      </span>
      <div
        class="bag-item__bopis"
        v-if="showBopis && isInStoreFulfillable"
      >
        <div class="bag-item__bopis__badge-icon" v-html="bopisIconHtml"></div>
        <span class="bag-item__bopis-details" v-html="bopisDetails"></span>
      </div>
      <section
        v-if="(!isWishlist && upSellItems?.heading && upSellItems?.items.length > 0)"
        class="cart-upsell"
      >
        <h5
          v-if="upSellItems?.heading"
          class="cart-upsell__heading"
        >
          {{ upSellItems.heading }}
        </h5>

        <VueAccordion
          :ariaTitle="upSellItems?.subheading || upSellItems.heading"
          :title="upSellItems?.subheading || upSellItems.heading"
          :buttonPlacement="'top'"
          :buttonClass="'cart-upsell__subheading'"
          :defaltOpen="true"
        >
        <template #opened-icon>
          <i
          class="cart-upsell__header-icon
          cart-upsell__header-icon--upsell icon icon--chevron-up">

          </i>
          <span class="screenreader">Minimize Options</span>
        </template>
        <template #closed-icon>
          <i
            class="cart-upsell__header-icon
            cart-upsell__header-icon--upsell icon icon--chevron-down"
          >
          </i>
          <span class="screenreader">Expand Options</span>
        </template>
        <CartUpsell
          :products="upSellItems?.items"
          :parentProductId="id"
          :parentFrameSpecId="frameSpecId"
          :parentProductProperties="itemProperties"
          :bagItems="cartItems"
          :isWishlist="isWishlist"
          :updateLoadingState="updateLoadingState"
        />
      </VueAccordion>
      </section>
      <StorePickupMessaging
        v-if="isInStoreFulfillable"
        :variantId="variantId"
        :selectedStore="selectedPickupStore"
        :frameSpec="frameSpec"
        :itemProperties="itemProperties"
        @open-store-selector="openPickupStoreSelector"
      />
    </div>
    </div>
    <VueModal
      :show="duplicateModalOpen"
      includeOverlay
      autoWidth
      @toggleModal="toggleModal"
    >
      <template #modal-content>
        <h4
          class="vue-modal__title"
        >
          {{ duplicateCaptionText }}
        </h4>
        <p class="vue-modal__copy">
          {{ duplicateCopyText }}
        </p>
        <div class="bag-item__qty increment js-increment">
          <input
            :value="duplicationCount"
            @input="onDuplicationCountInputChanged"
            type="number"
            name="duplicationCount"
            size="3" class="increment__input" tabindex="-1"
            aria-label="Duplication Count"
          />
          <button
            type="button"
            class="increment__btn increment__add"
            data-action="add"
            @click.prevent="incrementDuplicationCount"
          >
            <i class="increment__icon increment__icon--add bag-item__qty-icon icon icon--plus">
            </i>
            <span class="screenreader">Add</span>
          </button>
          <button
            type="button"
            class="increment__btn increment__subtr"
            data-action="remove"
            :disabled="duplicationCount === 1"
            @click.prevent="decrementDuplicationCount"
          >
            <i
              class="increment__icon increment__icon--subtr bag-item__qty-icon icon icon--minus"
            ></i>
            <span class="screenreader">Subtract</span>
          </button>
        </div>
        <p class="bag-item__qty-caption">Up to 20 at a time</p>
        <div class="vue-modal__actions">
          <button
            class="vue-modal__button btn btn--primary"
            type="button"
            @click.prevent="duplicateItem"
          >
            {{ duplicateConfirmText }}
          </button>
          <button
            class="vue-modal__button btn btn--secondary"
            type="button"
            @click.prevent="duplicateModalOpen = false"
          >
            {{ duplicateCancelText }}
          </button>
        </div>
      </template>
    </VueModal>
    <VueModal
      :show="(deleteModalOpen)"
      :includeOverlay="(true)"
      @toggleModal="toggleModal"
    >
      <template #modal-content>
        <h4
          class="vue-modal__title"
        >
          {{ isWishlist ? deleteWishlistModalTitleText : deleteModalTitleText }}
        </h4>
        <div class="vue-modal__actions">
          <button
            class="vue-modal__button btn btn--primary"
            @click.prevent="remove"
          >
            {{ isWishlist ? deleteWishlistModalConfirmText : deleteModalConfirmText }}
          </button>
          <button
            v-if="isWishlist"
            class="vue-modal__button btn btn--secondary"
            type="button"
            @click.prevent="moveToCart"
          >
            {{ deleteWishlistModalCancelText }}
          </button>
          <button
            v-else
            class="vue-modal__button btn btn--secondary"
            type="button"
            @click.prevent="moveToWishlist"
          >
            {{ deleteModalCancelText }}
          </button>
        </div>
      </template>
    </VueModal>
  </article>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import {
  computed,
  toRefs,
  ref,
  onMounted,
  toRaw,
  watch
} from 'vue';
import FrameSpec from '@framebridge/toolbox/FrameSpec';
import { duplicateBundleSpec } from '@framebridge/toolbox/BundleCartHelpers';
import useCart from '../composables/cart-actions';
import CartItemGallery from './CartItemGallery';
import useFrameSpecData from '../composables/cart-frame-spec';
import CartItemInstructions from './CartItemInstructions';
import CartUpsell from '../cart-upsell/CartUpsell';
import VueAccordion from '../common/accordion/Accordion';
import CartItemDeliveryMethod from '../cart-item-delivery-method/CartItemDeliveryMethod';
import CartItemDeliveryEstimate from '../cart-item-delivery-estimate/CartItemDeliveryEstimate';
import PriceBreakdownTooltip from '../price-breakdown-tooltip/PriceBreakdownTooltip';
import VueModal from '../common/modal/Modal';
import StorePickupMessaging from "./StorePickupMessaging";
import elevarTracking from '../../lib/elevar-tracking';
import trapFocus from "../../lib/trap-focus";

export default {
  name: 'CartItem',
  components: {
    CartItemDeliveryMethod,
    CartItemDeliveryEstimate,
    CartItemGallery,
    CartItemInstructions,
    CartUpsell,
    PriceBreakdownTooltip,
    StorePickupMessaging,
    VueAccordion,
    VueModal,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
      required: true,
    },
    allItems: {
      type: Array,
      default: () => [],
      required: true,
    },
    currency: {
      type: String,
      default: 'USD',
    },
    itemPrice: {
      type: Number,
      default: 0,
    },
    itemProperties: {
      type: Object,
      default: () => {},
    },
    selectedDropOffStore: {
      type: Object,
      default: () => ({}),
    },
    dropOffStores: {
      type: Object,
      default: () => ({}),
    },
    selectedShipToUsStore: {
      type: Object,
      default: () => ({}),
    },
    isWishlist: {
      type: Boolean,
      default: false,
    },
    checkoutAvailable: {
      type: Boolean,
      default: false,
    },
    hasPackageError: {
      type: Boolean,
      default: false,
    },
    togglePackingError: {
      type: Function,
      default: () => {},
    },
    bundleDetails: {
      type: Object,
      default: () => ({}),
    },
    sharedZipcode: {
      type: String,
      default: null,
    },
    selectedPickupStore: {
      type: Object,
      default: null,
    },
  },
  setup(props, context) {
    const {
      frameSpec,
      getFrameSpecById,
      cloneFrameSpec,
    } = useFrameSpecData();
    const {
      handle,
      id,
      image,
      options_with_values: options,
      product_title: title,
      product_type: productType,
      product_id: productId,
      properties,
      title: variantTitle,
      sku,
      url,
      variant_id: variantId,
      variant_options: variantOptions,
      enable_cart_duplication: enableCartDuplication,
      enable_cart_quantity: enableCartQuantity,
    } = toRefs(props.item);
    const itemQuantity = computed(() => props.item.quantity);
    const {
      item,
      selectedDropOffStore,
      selectedShipToUsStore,
      itemPrice,
      itemProperties,
      allItems,
      currency,
      isWishlist,
    } = toRefs(props);
    const {
      fetchCart,
      updateCartItemById,
      removeCartItemById,
      removeUpsellItem,
      moveItem,
      cartThemeSettings,
      cartItems,
    } = useCart();
    const {
      cartSummaryMailInServiceProductVariantId,
    } = cartThemeSettings;
    const duplicationCount = ref(1);
    const duplicateModalOpen = ref(false);
    const deleteModalOpen = ref(false);
    const isLoading = ref(false);
    const isFrameSpecLoading = ref(false);
    const isShippingTooltipOpen = ref(false);

    const duplicateTitleText = SDG.Data.cartDuplicateModalTitle || 'Duplicate Item';
    const duplicateCopyText = SDG.Data.cartDuplicateModalCopy || 'Would you like to duplicate this item?';
    const duplicateConfirmText = SDG.Data.cartDuplicateModalConfirm || 'Duplicate';
    const duplicateCancelText = SDG.Data.cartDuplicateModalCancel || 'Nevermind';
    const deleteModalTitleText = SDG.Data.cartDeleteModalTitle || 'Delete Item';
    const deleteModalConfirmText = SDG.Data.cartDeleteModalConfirm || 'Remove';
    const deleteModalCancelText = SDG.Data.cartDeleteModalCancel || 'Nevermind';
    const deleteWishlistModalTitleText = SDG.Data.wishlistDeleteModalTitle || 'Delete Item';
    const deleteWishlistModalConfirmText = SDG.Data.wishlistDeleteModalConfirm || 'Remove';
    const deleteWishlistModalCancelText = SDG.Data.wishlistDeleteModalCancel || 'Nevermind';
    const cartCheckoutPackageError = SDG.Data.cartCheckoutPackageError || 'Please let us know how you’ll get your item(s) to us.';
    const {
      bopisDetailedCopy,
      bopisIcon,
      bopisIconSrc,
      bopisEnable,
      bopisStorefrontApiKey,
    } = SDG.Data;
    // check if user is near a retail store
    const hasRetailContent = window.dataLayer?.find((item) => item.event === 'geolocation' && item.rule === 'retail-content');
    const bopisDetails = bopisDetailedCopy?.replace('[', '<span class="bag-item__bopis-details--green-text">')?.replace(']', '</span>');
    const showBopis = computed(() => (
      bopisEnable && !itemProperties.value['Includes'] && bopisStorefrontApiKey !== '' && bopisDetailedCopy && hasRetailContent
    ));
    const isInStoreFulfillable = ref(false);
    const allowSpecialInstructions = ref(false);
    const bopisIconHtml = ref(bopisIcon);

    // update BOPIS icon to use inline svg
    if (bopisIconSrc) {
      fetch(bopisIconSrc)
        .then((data) => data.text())
        .then((data) => {
          bopisIconHtml.value = data;
        });
    }

    const { dropOffStores } = toRefs(props);
    const availableDropOffStores = computed(() => toRaw(dropOffStores.value));
    const currentlySelectedStore = computed(() => toRaw(selectedDropOffStore.value));
    const upSellItems = ref({ heading: '', subheading: '', items: [] });
    const productHandle = handle.value;

    // eslint-disable-next-line no-underscore-dangle
    const dropOffStoreProperty = ref(itemProperties.value._dropOffAtStore);
    const packagingTypeKey = (typeof SDG !== 'undefined' && SDG?.Data?.cart?.packaging_type_property_label) || 'Packaging Type';
    const shipToUsProperty = ref(itemProperties.value[packagingTypeKey] || itemProperties.value.shipToUs);
    const bundleSpecNumber = ref(itemProperties.value._bundle_spec_number);
    const bundleSpecAuthToken = ref(itemProperties.value._bundle_spec_authorization_token);
    const isGWP = ref(itemProperties.value?._is_gwp === 'true');

    const moneyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency?.value || 'USD',
    });
    const formatPrice = (price) => moneyFormatter.format(price).replace(/(\.|,)00$/g, '');

    const getProductMetafields = () => {
      const upsellURL = `/products/${handle.value}?view=cart-upsell`;
      fetch(upsellURL)
        .then((res) => res.json())
        .then((upsellData) => {
          const { cartUpsell, inStoreFulfillable, specialInstructions } = upsellData || {};

          if (inStoreFulfillable) {
            isInStoreFulfillable.value = inStoreFulfillable;
          }
          if (specialInstructions) {
            allowSpecialInstructions.value = specialInstructions;
          }
          if (!cartUpsell) return;

          const { heading, subheading } = cartUpsell || '';
          const variantUpsellItems = cartUpsell[variantId.value];

          if (variantUpsellItems?.length > 0) {
            upSellItems.value = {
              heading,
              subheading,
              items: variantUpsellItems,
            };
          }
        })
        .catch((err) => console.error(err));
    };

    const handleSetShipToUs = (data) => {
      shipToUsProperty.value = data;

      context.emit('setShipToUs', data);
    };

    watch([selectedDropOffStore, selectedShipToUsStore], ([newStoreValue, newShipValue]) => {
      const selectedStore = toRaw(newStoreValue);
      const selectedShip = toRaw(newShipValue);

      if (!selectedStore && !selectedShip) return;
      if (selectedStore?.storeName && id.value === selectedStore?.itemId) {
        dropOffStoreProperty.value = selectedStore.storeName;
        shipToUsProperty.value = null;
      } else if (selectedShip?.shipOption && id.value === selectedShip?.itemId) {
        dropOffStoreProperty.value = null;
        shipToUsProperty.value = selectedShip.shipOption;
      }
    });

    const shippingFeeProduct = computed(() => {
      if (item.value.properties?._is_shipping_fee === 'true' || SDG?.Data?.cartThemeSettings?.cartSummaryMailInServiceProductVariantId === item.value.variant_id) {
        return true;
      }
      return false;
    });

    onMounted(() => {
      // no need to run if shipping fee product
      if (shippingFeeProduct.value) {
        return;
      }

      getProductMetafields();

      if (frameSpecId?.value && !frameSpecId?.value.includes('SS-')) {
        isFrameSpecLoading.value = true;

        getFrameSpecById(frameSpecId.value, frameSpecAuthToken.value)
          .then(() => {
            isFrameSpecLoading.value = false;
          })
          .catch((err) => {
            console.error(err);
            isFrameSpecLoading.value = false;
          });
      }
    });
    const isPhysical = computed(() => {
      if (productType?.value && productType.value.toLowerCase().includes('art print frame')) {
        if (!frameSpec.value) {
          return false;
        }
        return frameSpec.value.artworks[0].conveyance === "shipped";
      }

      if (productType?.value && productType.value.toLowerCase().includes('gift card')) {
        return false;
      }

      return variantOptions.value.includes('Physical');
    });
    const isBundle = computed(() => {
      if (productType?.value && productType.value.toLowerCase() === 'frame bundle') {
        return true;
      }

      return false;
    });
    const duplicateCaptionText = computed(() => (
      productType?.value?.toLowerCase() === 'finished good'
        ? 'Love this product?'
        : 'Love this design?'
    ));
    const bundleAdditions = computed(() => {
      if (!isBundle.value || !itemProperties.value._bundle_spec_number) {
        return [];
      }

      return allItems.value.filter(
        (item) => item?.properties?._parent_bundle_spec
          && item?.properties?._parent_bundle_spec === bundleSpecNumber?.value,
      );
    });

    const amountPrice = computed(() => {
      // eslint-disable-next-line no-underscore-dangle
      const upSellItemPrice = itemProperties.value?._upsell_price || false;
      const frameSpecPricing = frameSpec?.value?.pricing?.totalPrice || false;
      const money = itemPrice.value / 100;

      if (upSellItemPrice) {
        const additonalFee = parseInt(upSellItemPrice, 10) / 100;
        if (frameSpecPricing) {
          const totalCost = frameSpecPricing + additonalFee;

          return totalCost;
        }
        const totalCost = money + additonalFee;

        return totalCost;
      }

      if (frameSpecPricing) {
        return frameSpecPricing;
      }

      if (isGWP.value) {
        return 'Free';
      }

      if (bundleAdditions.value.length) {
        const bundleAdditionsPrice = bundleAdditions.value.reduce(
          (acc, item) => acc + item.final_line_price,
          0,
        ) / 100;
        return money + bundleAdditionsPrice;
      }

      return money;
    });
    const moneyPrice = computed(() => {
      if (typeof amountPrice.value === 'number') {
        return formatPrice(amountPrice.value);
      }

      return amountPrice.value;
    });
    const bundlePricing = computed(() => {
      if (!isBundle.value || !bundleAdditions.value.length) {
        return null;
      }

      const chargesCounts = bundleAdditions.value.reduce((acc, item) => ({
        ...acc,
        [item.handle]: acc[item.handle] ? acc[item.handle] + 1 : 1,
      }), {});
      const charges = Object.values(bundleAdditions.value.reduce((acc, addition) => {
        if (acc[addition.handle]) {
          acc[addition.handle].amount += addition.final_line_price / 100;
        } else {
          acc[addition.handle] = {
            amount: addition.final_line_price / 100,
            key: addition.handle,
            presentation: `${
              addition.product_title
            } ${
              chargesCounts[addition.handle] > 1
                ? `(${chargesCounts[addition.handle]})`
                : ''
            }`,
          };
        }
        return acc;
      }, {}));

      return {
        totalPrice: amountPrice.value,
        charges: [
          {
            amount: itemPrice.value / 100,
            key: handle.value,
            presentation: title.value,
          },
          ...charges,
        ],
      };
    });
    const isDigitalItem = computed(() => options.value.some((option) => option.value === 'Digital'));

    // Process title to convert [text] to <sup>text</sup> for proper HTML rendering
    const processedTitle = computed(() => {
      return title.value.replace(/\[/g, '<sup>').replace(/\]/g, '</sup>');
    });

    const childProduct = computed(() => {
      const { _parent_design: parentDesign } = itemProperties.value || {};

      if (parentDesign) {
        return true;
      }

      return false;
    });
    const isNonEditable = computed(() => {
      const uneditableTypes = SDG.Data.cartUneditableTypes || 'art print frame, finished good, gallery wall consultation, shopify gift card';
      const uneditableTypesArray = uneditableTypes.split(', ');
      const isUneditable = uneditableTypesArray.includes(productType.value.toLowerCase());

      return isUneditable || isGWP.value;
    });

    const mainDetails = computed(() => {
      if (isNonEditable.value) {
        const optionsDetails = options.value.reduce((obj, item) => {
          if (item.name === 'Amount' && item.value === 'Custom Amount' && properties.value?.customAmount) {
            return { ...obj, [item.name]: `$${properties.value.customAmount}` };
          }
          return { ...obj, [item.name]: item.value };
        }, {});

        if (properties.value?.['Recipient Email'] || properties.value?.recipientEmail) {
          optionsDetails['Recipient Email'] = properties.value['Recipient Email'] || properties.value.recipientEmail;
        }

        return optionsDetails;
      }

      if (properties.value === null) return null;

      const props = properties.value || {};
      const {
        'Final Frame Size': finalSize,
        Includes,
        'Art Type': artType,
        'Art Size': artSize,
      } = props;
      const packagingTypeLabel = (typeof SDG !== 'undefined' && SDG?.Data?.cart?.packaging_type_property_label) || 'Packaging Type';
      const shipToUs = props[packagingTypeLabel] || props.shipToUs;

      const details = {
        'Art Type': artType,
        'Final Frame Size': finalSize,
        'Art Size': artSize,
        Includes,
      };

      if (shipToUs && shipToUs !== 'temp_ship') {
        details[packagingTypeLabel] = shipToUs;
      }

      return details;
    });

    const requiresShippingSurcharge = computed(() => {
      if (properties.value === null) return false;

      const largeSizeGroups = ['Extra Large', 'Grand', 'Extra Grand', 'Mega'];
      const artSize = properties.value['Art Size'] || properties.value['Photo Size'];

      if (!artSize) return false;

      const sizeGroupMatch = artSize.split('•')[0]?.trim();
      return largeSizeGroups.includes(sizeGroupMatch);
    });

    const itemDetails = computed(() => {
      if (properties.value === null) return null;

      const props = properties.value || {};
      const {
        'Frame Style': frameStyle,
        'Photo Size': photoSize,
        'Mat Style': matStyle,
        'Mat Caption': matCaption,
        'Story Pocket': storyPocket,
      } = props;
      const sendDate = props['Send Date'] ?? props.sendDate;
      const recipientGiftNote = props['Recipient Gift Note'] ?? props.recipientGiftNote;

      const isDigitalGiftCard = options.value?.some(
        (option) => option.name === 'Gift Card Type' && option.value?.toLowerCase() === 'digital'
      );

      const standardDetails = !photoSize && !matStyle && !matCaption && !storyPocket;
      const giftCardDetails = isDigitalGiftCard ? (!sendDate && !recipientGiftNote) : true;

      if (standardDetails && giftCardDetails) {
        return false;
      }

      const formatSendDate = (date) => {
        if (!date) return null;
        const dateArr = date.split('-');
        const year = dateArr[0];
        const month = dateArr[1];
        const day = dateArr[2];
        return `${month}/${day}/${year}`;
      };

      const result = {
        'Frame Style': frameStyle || null,
        'Photo Size': photoSize || null,
        'Mat Style': matStyle || null,
        'Mat Caption': matCaption || null,
        'Story Pocket': storyPocket || null,
      };

      if (isDigitalGiftCard) {
        result['Send On'] = formatSendDate(sendDate);
        result['Message'] = recipientGiftNote || null;
      }

      return result;
    });

    const frameSpecId = computed(() => {
      if (properties.value === null) return null;

      const { _frame_spec_number: frameSpecItemId } = properties.value || {};

      return frameSpecItemId || null;
    });

    const frameSpecAuthToken = computed(() => {
      if (properties.value === null) return null;

      const { _frame_spec_authorization_token: token } = properties.value || {};

      return token || null;
    });

    const incrementDuplicationCount = () => {
      if (duplicationCount.value >= 20) {
        return;
      }

      duplicationCount.value += 1;
    };
    const decrementDuplicationCount = () => {
      duplicationCount.value -= 1;
    };

    const incrementQuantity = () => {
      const newQty = itemQuantity.value + 1;
      isLoading.value = true;
      updateCartItemById(
        null,
        id.value,
        itemProperties.value,
        newQty,
        isWishlist.value,
        null,
        () => { isLoading.value = false; }
      );
    };

    const decrementQuantity = () => {
      const newQty = itemQuantity.value - 1;
      if (newQty < 1) {
        return;
      }
      isLoading.value = true;
      updateCartItemById(
        null,
        id.value,
        itemProperties.value,
        newQty,
        isWishlist.value,
        null,
        () => { isLoading.value = false; }
      );
    };

    const remove = (event) => {
      const closeModal = (val) => {
        deleteModalOpen.value = val;
      };

      isLoading.value = true;
      __.addClass(event?.target, 'is-loading');
      removeCartItemById(
        event,
        id.value,
        isWishlist.value,
        true,
        () => {
          closeModal(false);

          // elevar tracking
          elevarTracking(props.item, 'remove');
        },
      );
    };

    const moveToWishlist = (event) => {
      const { _upsell_parent: upSellParent } = itemProperties.value || false;

      function moveWishlistItem() {
        isLoading.value = true;
        moveItem(event, id.value);
      }

      if (upSellParent && upSellParent === 'true') {
        const { _upsell_item_variant_id_list: upsellVariantList } = itemProperties.value || {};

        removeUpsellItem(
          upsellVariantList,
          id.value,
          itemProperties.value,
          0,
          true,
          moveWishlistItem,
        );
      } else {
        moveWishlistItem();
      }
    };

    const moveToCart = (event) => {
      isLoading.value = true;
      moveItem(event, id.value, true);
    };

    const toggleModal = (value) => {
      duplicateModalOpen.value = value;
      deleteModalOpen.value = value;
    };

    const toggleShippingTooltip = (shouldOpen) => {
      isShippingTooltipOpen.value = shouldOpen;
    };

    const duplicateItem = async (event) => {
      const closeModal = () => {
        duplicateModalOpen.value = false;

        // setTimeout is employed to prevent premature activation of the Checkout button
        // in case the user dismisses the duplication loading modal and attempts to
        // immediately interact with the Checkout button
        setTimeout(() => {
          context.emit('toggleCheckoutButton', false);
        }, 500);
      };

      context.emit('toggleCheckoutButton', true);

      if (!variantId?.value) {
        console.error('No variantId data');
        return;
      }
      const frameSpecReorderArr = ['curated design frame', 'custom frame'];
      const isFrameSpecDuplicate = frameSpecReorderArr.includes(productType.value?.toLowerCase());

      let addToCartData;

      if ((!frameSpec?.value || !isFrameSpecDuplicate) && !isBundle.value) {
        if (!itemProperties?.value) {
          addToCartData = {
            items: [{
              id: `${variantId.value}`,
              quantity: 1,
            }],
          };
        } else {
          addToCartData = {
            items: [{
              id: `${variantId.value}`,
              quantity: 1,
              properties: {
                ...itemProperties.value,
              },
            }],
          };
        }

        SDG.Bag.addItem(addToCartData);
        closeModal();
        return;
      }

      if (event?.target) {
        __.addClass(event.target, 'is-loading');
        event.target.disabled = true;
      }

      try {
        const cartHost = SDG.Data.cartHost;

        if (isBundle.value) {
          const items = await duplicateBundleSpec(
            bundleSpecNumber.value,
            bundleSpecAuthToken.value,
            variantId.value,
            itemProperties.value,
            bundleAdditions.value,
            duplicationCount.value,
            SDG?.Data?.joineryHost,
          );

          console.log('adding items', items)

          await FrameSpec.saveToCart({ items, cartHost });
        } else {
          const groupedItems = await Promise.all(
            Array.from({ length: duplicationCount.value }).map(async () => {
              const clone = await cloneFrameSpec(frameSpec.value);
              clone.id = null;
              return clone.toCartItems();
            })
          );

          await FrameSpec.saveToCart({ items: groupedItems.flat(), cartHost });
        }
      } catch (err) {
        console.error({ message: 'Error duplicating item', error: err });
      }

      fetchCart();
      if (event?.target) {
        __.removeClass(event.target, 'is-loading');
        event.target.disabled = false;
      }
      closeModal();
    };

    const updateLoadingState = (value) => {
      isLoading.value = value;
    };

    const frameEditParams = computed(() => {
      if (isBundle.value) {
        const {
          _bundle_spec_number: bundleSpecId,
          _bundle_spec_authorization_token: token,
        } = itemProperties.value || null;

        if (bundleSpecId && token) {
          return `/apps/designer/bundle/${bundleSpecId}?line_id=${id.value}&product=${productId.value}&variant=${variantId.value}&token=${token}`;
        }
      }

      let params = `frame-spec=${frameSpecId.value}&line_id=${id.value}`;

      if (frameSpecAuthToken.value) {
        params += `&fs-auth-token=${frameSpecAuthToken.value}`;
      }
      return `/apps/designer/review-your-frame?${params}`;
    });

    const onDuplicationCountInputChanged = (event) => {
      if (!event.target.value) {
        return;
      }

      if (event.target.value > 20) {
        duplicationCount.value = 20;
        return;
      }

      duplicationCount.value = parseInt(event.target.value);
    };

    const onZipcodeUpdated = (data) => {
      // Emit event to parent Cart component to handle zipcode update
      context.emit('zipcode-updated', {
        itemId: id.value,
        zipcode: data.zipcode,
        deliveryDate: data.deliveryDate,
      });
    };

    const openPickupStoreSelector = () => {
      const $body = document.body;
      __.addClass($body, "is-store-selector-exposed");
      const $storeSelectorModal = document.getElementById("storeSelectorModal");
      const $hiddenItemId = $storeSelectorModal.querySelector(".js-hidden-item-id");
      $hiddenItemId.value = id.value;
      const $hiddenItemProperties = $storeSelectorModal.querySelector(".js-hidden-item-properties");
      $hiddenItemProperties.value = JSON.stringify(itemProperties.value);

      setTimeout(() => {
        trapFocus($storeSelectorModal);
      }, 150);
    };

    return {
      cartItems,
      childProduct,
      shippingFeeProduct,
      duplicateCancelText,
      duplicateCopyText,
      duplicateConfirmText,
      duplicateTitleText,
      duplicateModalOpen,
      deleteModalOpen,
      deleteModalTitleText,
      deleteModalConfirmText,
      deleteModalCancelText,
      deleteWishlistModalTitleText,
      deleteWishlistModalConfirmText,
      deleteWishlistModalCancelText,
      enableCartDuplication,
      enableCartQuantity,
      itemQuantity,
      incrementQuantity,
      decrementQuantity,
      duplicateCaptionText,
      frameSpec,
      frameSpecId,
      id,
      image,
      itemDetails,
      isDigitalItem,
      isNonEditable,
      mainDetails,
      moneyPrice,
      bundlePricing,
      title,
      sku,
      url,
      upSellItems,
      variantId,
      variantTitle,
      duplicateItem,
      duplicationCount,
      incrementDuplicationCount,
      decrementDuplicationCount,
      remove,
      isPhysical,
      availableDropOffStores,
      dropOffStoreProperty,
      selectedPickupStore: computed(() => props.selectedPickupStore),
      currentlySelectedStore,
      shipToUsProperty,
      moveToWishlist,
      moveToCart,
      toggleModal,
      isFrameSpecLoading,
      isLoading,
      updateLoadingState,
      productHandle,
      handleSetShipToUs,
      frameEditParams,
      bundleSpecNumber,
      bundleSpecAuthToken,
      isGWP,
      onDuplicationCountInputChanged,
      cartCheckoutPackageError,
      bopisDetails,
      bopisIconHtml,
      showBopis,
      isInStoreFulfillable,
      allowSpecialInstructions,
      onZipcodeUpdated,
      openPickupStoreSelector,
      requiresShippingSurcharge,
      isShippingTooltipOpen,
      toggleShippingTooltip,
      sharedZipcode: computed(() => props.sharedZipcode)
    };
  },
};
</script>
